import { isEmpty } from 'lodash';
import { LOGIN, PLATFORM } from './constants';
var DISABLE_LOCAL_TRACKING = true;
var ChurnZeroService = /** @class */ (function () {
    function ChurnZeroService(api, appKey) {
        var _a;
        this.churnZeroApi = null;
        this.loggedIn = false;
        this.churnZeroApi = api;
        (_a = this.churnZeroApi) === null || _a === void 0 ? void 0 : _a.push(['setAppKey', appKey]);
        this.loggedIn = false;
    }
    ChurnZeroService.init = function (config) {
        var isLocal = !config.environment || config.environment === 'local';
        var isEnvOk = isLocal ? !DISABLE_LOCAL_TRACKING : true;
        var isLoaded = window.ChurnZero && !isEmpty(window.ChurnZero);
        var isConfigured = !!config.appKey;
        var shouldInit = isEnvOk && isLoaded && isConfigured;
        if (shouldInit) {
            ChurnZeroService.instance = new ChurnZeroService(window.ChurnZero, config.appKey);
        }
    };
    ChurnZeroService.prototype.shouldTrack = function () {
        return !!this.churnZeroApi;
    };
    ChurnZeroService.track = function (eventName, description) {
        var _a, _b;
        var shouldTrack = ((_a = ChurnZeroService.instance) === null || _a === void 0 ? void 0 : _a.shouldTrack()) && ((_b = ChurnZeroService.instance) === null || _b === void 0 ? void 0 : _b.loggedIn);
        if (shouldTrack) {
            ChurnZeroService.instance.churnZeroApi.push(['trackEvent', eventName, description]);
        }
    };
    ChurnZeroService.login = function (shopId, brandId) {
        var _a;
        if ((_a = ChurnZeroService.instance) === null || _a === void 0 ? void 0 : _a.shouldTrack()) {
            if (ChurnZeroService.instance.loggedIn) {
                ChurnZeroService.logout();
            }
            ChurnZeroService.instance.churnZeroApi.push(['setContact', shopId, brandId || shopId]);
            ChurnZeroService.instance.loggedIn = true;
            ChurnZeroService.track(LOGIN, PLATFORM);
        }
    };
    ChurnZeroService.logout = function () {
        var _a;
        if ((_a = ChurnZeroService.instance) === null || _a === void 0 ? void 0 : _a.shouldTrack()) {
            ChurnZeroService.instance.churnZeroApi.push(['stop']);
            ChurnZeroService.instance.loggedIn = false;
        }
    };
    ChurnZeroService.instance = null;
    return ChurnZeroService;
}());
export { ChurnZeroService };
